import React from 'react'
import { useDispatch } from 'react-redux'
import { logoutAndRedirect } from '../../actions/auth'

const RefreshApp = () => {
  const dispatch = useDispatch()
  return (
    <div id="refreshAppWrapper">
      <div id="refreshApp">
        Your courses have been updated. Please save your work and update ASAP.
        <div
          className="button"
          onClick={() => {
            dispatch(logoutAndRedirect(true))
          }}
        >
          Update Quest!
        </div>
      </div>
    </div>
  )
}

export default RefreshApp
